import React from "react"
import {
	DataTable,
	DataTableBody,
	DataTableHead,
	DataTableRow,
} from "@walmart-web/livingdesign-components"
import ChartContainer from "components/Shared/ChartContainer"
import "./index.scss"
import { InformationTableProps } from "./interfaces"
import { ID_GENERIC_TABLE } from "./constants"
import DataHeader from "./DataHeader"
import FooterTable from "./FooterTable"
import SubTitleTable from "./SubTitleTable"
import withVisibility from "../Hocs/withVisibility/withVisibility"

const InformationTable: React.FC<InformationTableProps> = ({
	id = ID_GENERIC_TABLE,
	data,
	className,
	titleTable,
	contentSubTitle,
	columnsHeader,
	rowsBody,
	defaultSorting,
	contentFooterTable,
	onSort = () => {},
}): JSX.Element => {
	const handleChangeDataTable = (dataTable: any) => onSort(dataTable)

	return (
		<div className="container-data-table">
			<ChartContainer title={{ id: titleTable || "phronesis.blank.space" }}>
				{<SubTitleTable content={contentSubTitle} />}
				<DataTable UNSAFE_className={className} id={`${id}-table`}>
					<DataTableHead>
						<DataTableRow>
							<DataHeader
								defaultSorting={defaultSorting}
								columnsHeader={columnsHeader}
								dataTable={data}
								onSort={handleChangeDataTable}
							></DataHeader>
						</DataTableRow>
					</DataTableHead>
					<DataTableBody>{rowsBody}</DataTableBody>
				</DataTable>
				{contentFooterTable && <FooterTable content={contentFooterTable} />}
			</ChartContainer>
		</div>
	)
}

export default withVisibility(InformationTable)
